import { useState, useEffect } from "react";
import LandingPageStyles from "./LandingPage.module.scss";
import { useAppSelector, useAppDispatch } from "../../hooks/store";

import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer/Footer";
import { LOCAL_STORAGE_KEYS, sidebarContent } from "../../common/constants";
import { getProjectMappings } from "../../services/common.service";
import {
  ReactNode,
  useEffect as useReactEffect,
  useState as useReactState,
} from "react";
import AstroBubble from "../../assets/AstroAsk.png";
import AgenticChatbot from "../../modules/AgenticChatbot/AgenticChatbot";
import AstroTesting from "../../assets/Astro_testing.svg";
import { getChatHistory } from "../../services/agent.service";
import { storeChatHistory } from "../../modules/vscDashboard/store/dashboard.thunk";

interface Props {
  children?: ReactNode;
  showFooter?: boolean;
  drawerOpen?: boolean;
  toggleDrawer?: (open: boolean) => void;
  haveRightContainer?: boolean;
}

const LandingPage = ({
  children,
  showFooter,
  drawerOpen,
  toggleDrawer,
  haveRightContainer = true,
}: Props) => {
  const [isSideDrawerOpen, setIsSideDrawerOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [showButtons, setShowButtons] = useState([]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isSideDrawerOpen) return; // drawer is closed → skip the call

    (async () => {
      try {
        // const dateTimeValue = localStorage.getItem("DATE_TIME_FORMAT");

        const conversationId = localStorage.getItem(
          LOCAL_STORAGE_KEYS.AGENTIC_CONVERSATION_ID
        );
        // Step 2: Build the argument object

        // Step 3: Pass to getChatHistory
        const response = await getChatHistory({
          current_session: conversationId,
        });
        dispatch(storeChatHistory(response));

        let lastAgentResponseJson = null;

        // Search from the end for the last non-empty agent_response_json
        for (let i = response.length - 1; i >= 0; i--) {
          if (
            response[i].agent_response_json &&
            response[i].agent_response_json.trim() !== ""
          ) {
            lastAgentResponseJson = response[i].agent_response_json;
            break;
          }
        }

        let suggestedOptions = [];
        if (lastAgentResponseJson) {
          // Replace single quotes with double quotes for valid JSON
          const jsonStr = lastAgentResponseJson.replace(/'/g, '"');

          const responseObj = JSON.parse(jsonStr);
          suggestedOptions = responseObj.list_of_suggested_options || [];
        }

        setChatHistory(response);

        setShowButtons(suggestedOptions); // Assuming each item has a showButtons property
      } catch (err) {
        /* handle / log error here */
      }
    })();
  }, [isSideDrawerOpen]);

  // Determine current project (prefer localStorage, else fetch)
  const [currentProject, setCurrentProject] = useReactState<string | null>(
    null
  );

  useReactEffect(() => {
    // Try to get from localStorage first
    const storedProject = localStorage.getItem("currentProject");
    if (storedProject) {
      setCurrentProject(storedProject);
    } else {
      // Fallback: fetch from backend (like Dashboard)
      getProjectMappings().then((response) => {
        if (
          response &&
          response.project_names &&
          response.project_names.length > 0
        ) {
          const orionProject = response.project_names.find(
            (name: string) => name === "Orion"
          );
          setCurrentProject(orionProject || response.project_names[0]);
        }
      });
    }
  }, []);

  // Filter sidebarContent for Sourcing Hub
  let filteredSidebarContent = sidebarContent;
  if (currentProject === "SourcingHub") {
    filteredSidebarContent = { ...sidebarContent };
    // Remove Verizon logo (assuming it's the sourcingHubDashboard entry)
    delete filteredSidebarContent.sourcingHubDashboard;
    // Remove last option "Orion GSA" (if present as a key)
    // Already removed above, but if there are other keys, filter as needed
  }

  return (
    <div className={LandingPageStyles.container}>
      <Sidebar sidebarContent={filteredSidebarContent} />
      {/* <SideDrawer
       
      /> */}
      {haveRightContainer ? (
        <div className={LandingPageStyles.rightContainer}>
          <div className={LandingPageStyles.content}>
            {/* <Navbar /> */}
            {children}
          </div>
          {showFooter && <Footer />}
        </div>
      ) : (
        children
      )}
      <div>
        <div>
          <button
            type="button"
            className={LandingPageStyles.astroBubbleButton}
            onClick={() => {
              setIsSideDrawerOpen(true); // Open the side drawer

              // initialAgenticAICall(); // Call the API
            }}
          >
            <img
              src={AstroBubble}
              alt="Astro Bubble"
              style={{ width: "25px", height: "25px" }}
            />
            <span className={LandingPageStyles.askAstroText}>Ask Orion</span>
          </button>
        </div>
      </div>
      {isSideDrawerOpen && (
        <AgenticChatbot
          isOpen={isSideDrawerOpen}
          toggleDrawer={(open) => () => setIsSideDrawerOpen(open)}
          // chatHistory={chatHistory}
          showAllButtons={showButtons}
          setChatHistory={setChatHistory}
        />
      )}
    </div>
  );
};

export default LandingPage;
